/* eslint-disable react-refresh/only-export-components -- context provider and
   its hook live together by design (fixture notification inbox, design B5). */
import { createContext, useContext, useState, useMemo, useCallback, type ReactNode } from 'react';
import { notifications as initialNotifications, type NotificationItem } from '@/mocks/notificationsData';

interface NotificationContextValue {
  items: NotificationItem[];
  unreadCount: number;
  markAsRead: (id: string) => void;
  markAllRead: () => void;
  setItems: (updater: NotificationItem[] | ((prev: NotificationItem[]) => NotificationItem[])) => void;
}

const NotificationContext = createContext<NotificationContextValue | null>(null);

export function NotificationProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<NotificationItem[]>(initialNotifications);

  const unreadCount = useMemo(() => items.filter((n) => !n.read).length, [items]);

  const markAsRead = useCallback((id: string) => {
    setItems((prev) =>
      prev.map((n) => (n.id === id ? { ...n, read: true } : n)),
    );
  }, []);

  const markAllRead = useCallback(() => {
    setItems((prev) => prev.map((n) => ({ ...n, read: true })));
  }, []);

  return (
    <NotificationContext.Provider value={{ items, unreadCount, markAsRead, markAllRead, setItems }}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotifications() {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error('useNotifications must be used within NotificationProvider');
  return ctx;
}